import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';


import { AddCashInComponent } from './addCashIn.component';

import { CashInService, SubscribeService } from '../../../services/index';
import * as moment from 'moment';

//import { AddEditSkuComponent } from './addEditSku.component';
//import { NgxPageSize } from '../../shared/index';

//import { SkuService } from '../../services/index';
import { CashInModal } from '../../../model/index';

// import * as fromSkuStore from '../../store';
// import * as skuActions from '../../store/actions/sku.actions';
// import * as fromRootStore from '../../reducers';
//import { AppMenu } from '../../../app.component.menu';
//import { AppMenuService } from '../../../app.component.service';
//import { TabsComponent} from '../../../tabs.component';

@Component({
    selector: 'cash-in-list',
    templateUrl: './cashIn.component.html'
})
export class CashInComponent implements OnInit {
    // @Input('tabTitle') title: string;
    // @Input() active = false;
    // @Input() isCloseable = false;
    // @Input() dataContext;
    //
    isLoadMask: Promise<any>;
    cashInListData: CashInModal[];
    //
    loadingIndicator: boolean = true;
    public mode: string;
    // reorderable: boolean = true;
    //
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        // orderBy: 'company_name',
        // orderDir: 'asc'
    };
    //
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    //
    columns = [];
    toggleCol = [];
    // filterExpand = false;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
        "search_data": ""
        
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, private cashInService: CashInService, public subscribeService: SubscribeService) {
        //console.log(this.gs.rootObj);
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Cash Out No', prop: 'cash_out_no', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Cash Out Date', prop: 'cashout_date', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            // { name: 'Cash From ', prop: 'out_type', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'From Branch', prop: 'branch_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'To Branch', prop: 'to_branch', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'HV Team', prop: 'hv_username', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Amount', prop: 'tot_amount', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-right' },
            { name: 'Cash In No', prop: 'cash_in_no', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Cash In Date', prop: 'cashin_date', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            { name: 'Action', prop: 'action', width: 240, minWidth: 240, maxWidth: 240, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        // this.subscribeService.subscribe(($e) => {
        //     this.pageCallback({ offset: 0 });
        // });
        this.subscribeService.publishReloadCashInGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getCashInDateList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getCashInDateList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date(),
            "search_data": ""
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getCashInDateList();
    }
    getCashInDateList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD')
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            // orderColumn: `${this.page.orderBy}`,
            // orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(filterData)
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.cashInService
            .getCashInList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.cashInListData = res.data;
            });
    }
    addEditCashIn(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        row['mode'] = mode;

        if (mode == "Add") {
            row['btnTxt'] = 'Save';
        } else if (mode == "Edit") {
            row['btnTxt'] = 'Update';
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddCashInComponent', Object.assign({}, row), this['params']['tabParams']);
    }

    acceptCashIn(row: any): void {        
        let cashInDate = moment(new Date()).format('YYYY-MM-DD');
        let that = this,
            params: any = {
                // cash_in_no: row['cash_in_no'],
                cash_out_no: row['cash_out_no'],
                cash_out_id: row['cash_out_id'],
                cash_out_date: row['cash_out_date'],
                cash_in_date: cashInDate,
                out_type: row['out_type'],
                companyid: row['from_company_id'],
                hv_userid: row['out_type'] === 'HV Team' ? row['requested_by'] : 0,
                to_company_id: row['to_branch_id'],
                to_hv_userid: row['out_type'] === 'HV Team' ? row['to_hvuserid'] : 0,
                amount: row['tot_amount'],
                comments: row['comments'] ? row['comments'] : '',
                mode: 'Accept'
            };

        this.isLoadMask = that.isLoadMask = that.cashInService.addCashIn(params).then(function(res: any) {
            if (res.success) {
                swal(
                    'SUCCESS',
                    res.message,
                    'success'
                );
                that.subscribeService.subReloadCashInGrid();
            } else {
                swal(
                    'ERROR',
                    res.message,
                    'error'
                );
            }
        });
    }

    deleteCashIn(row: any): void {

        let that = this,
            data = {
                cash_out_id: row.cash_out_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Details',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.cashInService
                .deleteCashIn(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getCashInDateList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }
    
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashIn/cashIn.component.ts